<template>
	<div class="x_box">
		<ol class="breadcrumb x_breadcrumb">
			<li class="breadcrumb-item"><router-link to="/discipline/list">{{ $t("discipline") }}</router-link></li>
			<li class="breadcrumb-item active" aria-current="page">{{ $t("new") }}</li>
		</ol>
		<div class="x_header">
			<button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)">
				<i class="fa fa-arrow-circle-o-left"></i> {{ $t("back") }}
			</button>
			<button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="onSave"><i class="fa fa-floppy-o"></i> {{ $t("save") }}</button>
		</div>
		<div class="x_body">
			<div class="card x_card">
				<div class="card-body">
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="form-group" :class="{ 'form-group-error': $v.model.EmployeeId.$error }">
                                <label class="label-control blue">{{$t('employee_name')}}</label>
                                <div>
                                    <select class="form-control form-control-sm" v-model="$v.model.EmployeeId.$model">
                                        <option v-for="ret in employees" :value="ret.Id" :key="ret.Id">{{ret.Num}} : {{ret.KhmerName}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group" :class="{ 'form-group-error': $v.model.Date.$error }">
                                <label class="label-control blue">{{$t('date')}}</label>
                                <div>
                                    <input type="date" class="form-control form-control-sm" v-model="$v.model.Date.$model"/>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group" :class="{ 'form-group-error': $v.model.Date.$error }">
                                <label class="label-control blue">{{$t('date')}}</label>
                                <div>
                                    <select class="form-control form-control-sm" v-model="model.TypeId">
                                        <option value="Deduce Money">Deduce Money</option>
                                        <option value="None Deduce Money">None Deduce Money</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="form-group" :class="{ 'form-group-error': $v.model.Description.$error }">
                                <label class="label-control blue">{{$t('description')}}</label>
                                <div>
                                    <textarea class="form-control form-control-sm" v-model="$v.model.Description.$model"></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="label-control blue">{{$t('total_amount')}}</label>
                                <div>
                                    <input type="number" class="form-control form-control-sm" min="0" v-model="model.Amount"/>
                                </div>
                            </div>
                        </div>
                    </div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import { required } from 'vuelidate/lib/validators'
	import Swal from "sweetalert2";
	export default {
		data: function () {
			return {
				model: {
                    EmployeeId: '',
                    Description: '',
                    Date: this.$now().format('YYYY-MM-DD'),
                    TypeId: 0,
                    Amount: 0
				},
				employees: []
			}
		},
		validations:{
			model: {
				EmployeeId: { required },
                Description: { required },
                Date: { required }
			}
		},
		created: function () {
			this.listEmployee();
            var id = this.$route.params.id;
            if(id != undefined && id != null && id != ''){
                this.findById(id);
            }
		},
		methods: {
            findById(id){
                let loading = this.$loading.show();
                this.$api().post('employee/discipline/find', { Id: id }).then((res) => {
                    if (this.$isValid(res)) {
                        this.model = res.data.Json.Discipline;
                        this.model.Date = this.$format(this.model.Date, 'YYYY-MM-DD');
                    }
                }).finally(function () { loading.hide(); });
            },
			onSave: function () {
				this.$v.$touch();
				if(!this.$v.$invalid) {
					let loading = this.$loading.show();
					this.$api().post('employee/discipline/save', this.model).then((res) => {
						if (this.$isValid(res)) {
							Swal.fire('Success', 'The discipline save success.', 'success');
							this.$router.push("/discipline/list");
						}
					}).finally(function () {
						loading.hide();
					});
				}
			},
			listEmployee(){
				this.$api().post('employees', { Limit: 0 }).then(res => {
					this.employees = res.data.Data;
				});
			}
		}
	};
</script>
